$('.st-drawer-list__button').click(function() {
  $(this).toggleClass('js-active');

  var target = $(this).attr('aria-controls');
  $('#'+target).slideToggle();
})
